function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M68.118 5.14045H16.8821V41.8596H68.118V5.14045Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.118 42.5H16.8821C16.5277 42.5 16.2416 42.2139 16.2416 41.8596V5.14045C16.2416 4.78607 16.5277 4.5 16.8821 4.5H68.118C68.4724 4.5 68.7585 4.78607 68.7585 5.14045V41.8596C68.7585 42.2139 68.4724 42.5 68.118 42.5ZM17.5225 41.2191H67.4776V5.7809H17.5225V41.2191Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 9.41011H21.1517L16.8821 25.2079V28.2692H68.118V25.2079L63.8484 9.41011Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.118 28.9097H16.8821C16.5277 28.9097 16.2416 28.6236 16.2416 28.2692V25.2079C16.2416 25.1524 16.2502 25.0969 16.263 25.0413L20.5326 9.2436C20.6095 8.96607 20.8614 8.76966 21.1517 8.76966H63.8484C64.1387 8.76966 64.3906 8.9618 64.4675 9.2436L68.7371 25.0413C68.7499 25.0969 68.7585 25.1524 68.7585 25.2079V28.2692C68.7585 28.6236 68.4724 28.9097 68.118 28.9097ZM17.5225 27.6288H67.4776V25.2933L63.3573 10.0506H21.6427L17.5225 25.2933V27.6288Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9414 24.64H20.0587C19.858 24.64 19.6702 24.5461 19.5463 24.3838C19.4268 24.2216 19.3884 24.0166 19.4439 23.8202L22.8895 11.7926C22.9663 11.5193 23.2182 11.3272 23.5043 11.3272H61.5854C61.8715 11.3272 62.1234 11.5193 62.2045 11.7969L65.5562 23.8245C65.6117 24.0166 65.569 24.2258 65.4495 24.3838C65.3299 24.5418 65.1378 24.6357 64.9414 24.6357V24.64ZM20.9084 23.3591H64.096L61.103 12.6124H23.9911L20.9126 23.3591H20.9084Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3877 42.5H12.6124C12.258 42.5 11.972 42.2139 11.972 41.8596C11.972 41.5052 12.258 41.2191 12.6124 41.2191H72.3877C72.7421 41.2191 73.0281 41.5052 73.0281 41.8596C73.0281 42.2139 72.7421 42.5 72.3877 42.5Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 28.2692H21.1517V37.5899H63.8484V28.2692Z",
    fill: "#C4BFB6",
    style: {
      fill: "#C4BFB6",
      fill: "color(display-p3 0.7686 0.7490 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8484 38.2303H21.1517C20.7973 38.2303 20.5113 37.9443 20.5113 37.5899V28.2692C20.5113 27.9148 20.7973 27.6288 21.1517 27.6288H63.8484C64.2027 27.6288 64.4888 27.9148 64.4888 28.2692V37.5899C64.4888 37.9443 64.2027 38.2303 63.8484 38.2303ZM21.7922 36.9494H63.2079V28.9097H21.7922V36.9494Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6349 36.0955H40.3652C40.0108 36.0955 39.7248 35.8094 39.7248 35.4551C39.7248 35.1007 40.0108 34.8146 40.3652 34.8146H44.6349C44.9893 34.8146 45.2753 35.1007 45.2753 35.4551C45.2753 35.8094 44.9893 36.0955 44.6349 36.0955Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwning);
export default __webpack_public_path__ + "static/media/Awning.58311c34ca2957fc3e1c78d46acf24f6.svg";
export { ForwardRef as ReactComponent };